<template>
  <AppLayout>
    <div class="transaction fleet-module-page">
      <section class="container">
        <div class="fleet-stat-grid">
          <div class="fleet-stat-card"><span>Total Trips</span><strong>{{ tripStats.total }}</strong></div>
          <div class="fleet-stat-card"><span>Active</span><strong>{{ tripStats.active }}</strong></div>
          <div class="fleet-stat-card"><span>Completed</span><strong>{{ tripStats.completed }}</strong></div>
          <div class="fleet-stat-card"><span>Open Trips</span><strong>{{ tripStats.open }}</strong></div>
        </div>

        <div class="filter-search">
          <div class="filter-search-header"><p>Filter</p></div>
          <div class="filter-search-content">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Search</label>
                  <input v-model="filters.search" class="form-control" placeholder="Vehicle, driver, origin or destination..." />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Status</label>
                  <select v-model="filters.status" class="form-control">
                    <option value="">All</option>
                    <option value="Active">Active</option>
                    <option value="Completed">Completed</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="data-table-wrapper">
          <div class="table-toolbar d-flex align-items-center justify-content-between mb-2">
            <h6>Trips</h6>
            <button class="btn btn-primary btn-sm" @click="showAddTripModal = true">
              + Add Trip
            </button>
          </div>
                  <!-- Add Trip Modal -->
                  <div v-if="showAddTripModal" class="svc-modal-overlay" @click.self="closeAddTripModal">
                    <div class="svc-modal-box">
                      <div class="svc-modal-header">
                        <h6 class="fw-bold mb-0">Add Trip</h6>
                        <button class="btn-close-plain" @click="closeAddTripModal">&times;</button>
                      </div>
                      <div class="svc-modal-body">
                        <!-- Trip creation form will go here -->
                        <div class="row g-2">
                          <div class="col-12">
                            <label class="form-label" style="font-size:11px;">Vehicle</label>
                            <input class="form-control form-control-sm" disabled placeholder="Vehicle dropdown here" />
                          </div>
                          <div class="col-12">
                            <label class="form-label" style="font-size:11px;">Driver</label>
                            <input class="form-control form-control-sm" disabled placeholder="Driver dropdown here" />
                          </div>
                          <div class="col-12">
                            <label class="form-label" style="font-size:11px;">Start KMs</label>
                            <input class="form-control form-control-sm" disabled placeholder="Start KMs input here" />
                          </div>
                          <!-- Add more fields as needed -->
                        </div>
                      </div>
                      <div class="svc-modal-footer">
                        <button class="btn btn-sm btn-style-2" @click="closeAddTripModal">Cancel</button>
                        <button class="btn btn-sm btn-primary" disabled>Add Trip</button>
                      </div>
                    </div>
                  </div>
          <div class="table-wrap">
            <table ref="fleetTable" class="fleet-table table table-hover">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Vehicle</th>
                  <th>Driver</th>
                  <th>Origin</th>
                  <th>Destination</th>
                  <th>Start KMs</th>
                  <th>End KMs</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(t, index) in filteredTrips" :key="t.id || t.trip_id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ t?.vehicle?.plateNumber || '-' }}</td>
                  <td>{{ t?.driver?.user?.name || t?.driver?.name || '-' }}</td>
                  <td>{{ t?.requisition?.origin || '-' }}</td>
                  <td>{{ t?.requisition?.destination || '-' }}</td>
                  <td>{{ formatNumber(t.startKms) }}</td>
                  <td>{{ formatNumber(t.endKms) }}</td>
                  <td>
                    <span class="status-pill" :class="statusClass(getTripStatus(t))">{{ getTripStatus(t) }}</span>
                  </td>
                  <td>
                    <div class="table-actions">
                      <RouterLink class="mini-btn" :to="`/fleet/trips/${t.id || t.trip_id}`">View</RouterLink>
                      <button class="mini-btn" @click="openComplete(t)" :disabled="!!t.endTime">Complete</button>
                      <button class="mini-btn danger" @click="removeTrip(t)">Delete</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="showCompleteModal" class="svc-modal-overlay" @click.self="closeComplete">
          <div class="svc-modal-box">
            <div class="svc-modal-header">
              <h6 class="fw-bold mb-0">Complete Trip #{{ selectedTrip?.id || selectedTrip?.trip_id }}</h6>
              <button class="btn-close-plain" @click="closeComplete">&times;</button>
            </div>
            <div class="svc-modal-body">
              <div class="row g-2">
                <div class="col-12">
                  <label class="form-label" style="font-size:11px;">End KMs</label>
                  <input v-model.number="completeForm.endKms" type="number" min="0" class="form-control form-control-sm" />
                </div>
              </div>
            </div>
            <div class="svc-modal-footer">
              <button class="btn btn-sm btn-style-2" @click="closeComplete">Cancel</button>
              <button class="btn btn-sm btn-primary" @click="completeTrip" :disabled="saving">
                <span v-if="saving"><i class="fas fa-spinner fa-spin me-1"></i>Saving...</span>
                <span v-else>Submit Completion</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from '@/components/AppLayout.vue';
import fleetApi from '@/api/fleet';
import Swal from '@/utils/swal';
import 'datatables.net-vue3';
import 'datatables.net-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-responsive-bs5';
import $ from 'jquery';
import 'jszip';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.print.js';

export default {
  name: 'FleetTrips',
  components: { AppLayout },
  data() {
    return {
      trips: [],
      dataTable: null,
      filters: {
        search: '',
        status: '',
      },
      selectedTrip: null,
      showCompleteModal: false,
      completeForm: { endKms: null },
      saving: false,
      showAddTripModal: false,
    };
  },
  computed: {
    filteredTrips() {
      const filters = this.filters || { search: '', status: '' };
      const q = String(filters.search || '').toLowerCase().trim();
      return (this.trips || []).filter((t) => {
        const text = [
          t?.vehicle?.plateNumber,
          t?.driver?.user?.name,
          t?.driver?.name,
          t?.requisition?.origin,
          t?.requisition?.destination,
        ].filter(Boolean).join(' ').toLowerCase();
        const status = this.getTripStatus(t);
        const matchesSearch = !q || text.includes(q);
        const matchesStatus = !filters.status || status === filters.status;
        return matchesSearch && matchesStatus;
      });
    },
    tripStats() {
      const items = Array.isArray(this.trips) ? this.trips : [];
      const active = items.filter((t) => this.getTripStatus(t) === 'Active').length;
      const completed = items.filter((t) => this.getTripStatus(t) === 'Completed').length;
      return { total: items.length, active, completed, open: active };
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.initializeDataTable();
      },
    },
  },
  methods: {
    destroyDataTable() {
      if (this.dataTable && typeof this.dataTable.destroy === 'function') {
        this.dataTable.destroy();
        this.dataTable = null;
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        const tableElement = this.$refs.fleetTable;
        if (!tableElement) return;
        this.destroyDataTable();
        this.dataTable = $(tableElement).DataTable({
          responsive: true,
          destroy: true,
          pageLength: 10,
          lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, 'All']],
          language: {
            emptyTable: 'No trips found',
            paginate: {
              previous: '<i class="fa fa-chevron-left"></i>',
              next: '<i class="fa fa-chevron-right"></i>',
            },
          },
          dom: 'Bfrtip',
          buttons: [
            'colvis',
            'pageLength',
            {
              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-sm btn-outline-primary',
              exportOptions: { columns: ':visible' },
            },
          ],
        });
      });
    },
    notifyError(err) {
      this.$toast?.error?.(err?.message || 'Request failed');
    },
    formatNumber(v) {
      if (v === null || v === undefined || v === '') return '-';
      return new Intl.NumberFormat().format(Number(v));
    },
    getTripStatus(t) {
      return t?.endTime ? 'Completed' : 'Active';
    },
    statusClass(status) {
      if (status === 'Completed') return 'status-approved';
      if (status === 'Active') return 'status-pending';
      return 'status-default';
    },
    async loadTrips() {
      try {
        const tripsRes = await fleetApi.listTrips({ page: 1, limit: 200 });
        this.trips = fleetApi.unwrapList(tripsRes);
        this.initializeDataTable();
      } catch (err) {
        this.notifyError(err);
      }
    },
    openComplete(trip) {
      this.selectedTrip = trip;
      this.showCompleteModal = true;
      this.completeForm = { endKms: null };
    },
    closeComplete() {
      this.selectedTrip = null;
      this.showCompleteModal = false;
      this.completeForm = { endKms: null };
    },
    async completeTrip() {
      if (!this.selectedTrip) return;
      if (!this.completeForm.endKms && this.completeForm.endKms !== 0) {
        this.$toast?.warning?.('Enter End KMs');
        return;
      }
      this.saving = true;
      try {
        await fleetApi.completeTrip(this.selectedTrip.id || this.selectedTrip.trip_id, this.completeForm);
        this.$toast?.success?.('Trip completed');
        this.closeComplete();
        await this.loadTrips();
      } catch (err) {
        this.notifyError(err);
      } finally {
        this.saving = false;
      }
    },
    async removeTrip(t) {
      const id = t.id || t.trip_id;
      if (!id) return;
      const result = await Swal.fire({
        title: 'Delete this trip record?',
        text: 'This action cannot be undone!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
      });
      if (!result.isConfirmed) return;
      try {
        await fleetApi.deleteTrip(id);
        this.$toast?.success?.('Trip deleted');
        await this.loadTrips();
      } catch (err) {
        this.notifyError(err);
      }
    },
    closeAddTripModal() {
      this.showAddTripModal = false;
    },
  },
  mounted() {
    this.loadTrips();
  },
  beforeUnmount() {
    this.destroyDataTable();
  },
};
</script>

<style scoped>
@import './fleet.shared.css';
</style>
